<template>
  <!-- <div class="header-title">
    <span class="header-title-text">จัดการตำแหน่งงาน</span>
  </div> -->
  <div class="header-title header-title-text title-notab">
    <v-row class="pa-7 d-flex">
      <!-- <v-col cols="12" lg="6" md="6" class="ma-5"> -->
        <span>จัดการตำแหน่งงาน</span>
        <v-spacer></v-spacer>
      <!-- </v-col> -->
      <!-- <v-col cols="12" sm="6" md="6" lg="6" v-if="this.$route.name !== 'managePositionCreate'" class="pt-0 pb-0 d-flex justify-end mt-1"> -->
        <v-btn
          v-if="this.$route.name !== 'managePositionCreate'"
          outlined
          class="button-color-outline head-search-button mr-5"
          color="#2BA197"
          @click="openDialogUpload()"
        >
          <v-icon left dark class="icon-eye-color" size="14px">fa-cloud-upload-alt</v-icon>
          <!-- <span class="ra-text-in-button"> -->
            อัปโหลดไฟล์
          <!-- </span> -->
        </v-btn>
        <v-btn
          v-if="this.$route.name !== 'managePositionCreate'"
          class="button-color-outline head-search-button"
          outlined
          color="#2BA197"
          elevation="0"
          @click="openDialogDownload()"
        >
          <v-icon left size="14px">
            fa-cloud-download-alt
          </v-icon>
          ดาวน์โหลดไฟล์
        </v-btn>
      <!-- </v-col> -->
      <!-- <v-col v-if="this.$route.name !== 'managePositionCreate'" cols="12" sm="12" md="6" lg="3" class="pt-0 pb-0 d-flex align-center justify-start mt-1"> -->
        <!-- <v-btn
          outlined
          class="ra-button-employee"
          dark
          @click="gotocreate()"
        >
          <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
          <span class="ra-text-in-button-employee">
            เพิ่มพนักงาน
          </span>
        </v-btn> -->
        <!-- <v-btn
          class="button-color-outline head-search-button"
          outlined
          color="#2BA197"
          elevation="0"
          @click="openDialogDownload()"
        >
          <v-icon left size="14px">
            fa-cloud-download-alt
          </v-icon>
          ดาวน์โหลดไฟล์
        </v-btn>
      </v-col> -->
    </v-row>
    <DialogUploadFile/>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import DialogUploadFile from '../_dialog/dialogUploadFile.vue'
export default {
  components: {
    // OverlayLoading,
    DialogUploadFile
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    gotocreate () {
      this.$router.push('manageemployee/create')
    },
    openDialogUpload () {
      EventBus.$emit('opendialogUploadFile')
    },
    openDialogDownload () {
      EventBus.$emit('downloadFile')
    }
  }
}
</script>

<style scoped>
.ra-button-employee {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 9px 24px; */

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-button-upload {
  /* position: absolute; */
  /* height: 72px;
  left: 0px;
  right: 0px;
  top: 0px; */

  /* Color/Other/Background */

  background: #F8F9FA;
}
.ra-text-in-button-employee {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
